import Button from './Button';
import Link from 'next/link';
import { useRouter } from 'next/router';

const HowToUseSection = () => {
  const router = useRouter();
  const language = router.locale as SupportedLanguages;
  const isSpanish = language === 'es';

  return (
    <div className="mt-8 px-4 max-w-[1536px] 2xl:justify-self-center w-full">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-4">
        <div
          style={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundImage: `url(/monkey.png)`,
          }}
          className="w-full rounded-2xl flex flex-col justify-center text-white p-6"
        >
          <h3 className="how-to-use-section__step-te">
            <strong>{isSpanish ? 'Cómo usar' : 'How to use'}</strong> Tikipal
          </h3>
          <p className="w-36 text-sm pt-2">
            {isSpanish
              ? 'Compra en cualquier lugar las entradas para la fiesta'
              : 'Buy your tickets for the party anywhere'}
          </p>
          <div className="w-36 mt-4">
            <Link href="/how-to-use">
              <Button size="small">
                {isSpanish ? 'Más información' : 'More info'}
              </Button>
            </Link>
          </div>
        </div>

        <div
          style={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundImage: `url(/monkey2.png)`,
          }}
          className="w-full rounded-2xl flex flex-col justify-center text-white p-6"
        >
          <h3 className="how-to-use-section__step-te">
            <strong>{isSpanish ? 'Organiza' : 'Organize'}</strong>{' '}
            {isSpanish ? 'tu evento' : 'your event'}
          </h3>
          <p className="w-36 text-sm pt-2">
            {isSpanish
              ? 'Gestiona cumpleaños, eventos o conciertos'
              : 'Manage birthdays, events, or concerts'}
          </p>
          <div className="w-36 mt-4">
            <Link
              href="https://business.tikipal.co/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button size="small">
                {isSpanish ? 'Crear Evento' : 'Create Event'}
              </Button>
            </Link>
          </div>
        </div>

        <div
          style={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundImage: `url(/monkey3.png)`,
          }}
          className="w-full rounded-2xl flex flex-col justify-center text-white p-6"
        >
          <h3 className="how-to-use-section__step-te">
            <strong>{isSpanish ? 'Tiki' : 'Tiki'}</strong>
            {isSpanish ? 'aliados' : 'partners'}
          </h3>
          <p className="w-36 text-sm pt-2">
            {isSpanish
              ? 'Gestiona tus entradas y fideliza tus clientes'
              : 'Manage your tickets and build customer loyalty'}
          </p>
          <div className="w-36 mt-4">
            <Link
              href="https://business.tikipal.co/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button size="small">
                {isSpanish ? 'Registrar Aliado' : 'Register Partner'}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowToUseSection;
